module.exports = __webpack_public_path__ + "img/icon_lvjing_huidiao_normal@2x.0d62bed4.png";